<ng-template #viewPromptTemplate>
	@if (selectedPrompt(); as selectedPrompt) {
	<div [libFlexRow]="isMobileView()" [libFlexRowGap]="'16px'">
		<div libFlexColumn [libFlexSize]="isMobileView() ? 'full' : undefined">
			<lib-button (click)="handleCopySelectedResponse()" [icon]="'copy'" [buttonType]="'basic'"
				>Copy text</lib-button
			>
		</div>
		<div libFlexColumn [libFlexSize]="isMobileView() ? 'full' : undefined">
			<lib-button (click)="handleCopySelectedPrompt()" [icon]="'copy'" [buttonType]="'basic'"
				>Copy prompt</lib-button
			>
		</div>
	</div>
	<div class="push-top">
		<lib-message [type]="'info'" [title]="'Prompt'" [icon]="'question'">
			{{ selectedPrompt.prompt }}
		</lib-message>
	</div>
	<lib-card class="push-top">
		<div [innerHTML]="selectedPrompt.generatedText | textToHtml"></div>
	</lib-card>
	}
</ng-template>

<div [libFlexRow]="isMobileView()" [libFlexRowGap]="'16px'" [libFlexRowAlign]="'start'">
	<div libFlexColumn [libFlexSize]="isMobileView() ? 'full' : 'fill'">
		@if (!promptResponse()) {
		<div>
			<div>
				<lib-card>
					<div [libFlexRow]="isMobileView()" [libFlexRowGap]="'16px'">
						@if (clientContextToUse(); as clientContextToUse) {
						<div libFlexColumn [libFlexSize]="isMobileView() ? 'full' : 'fill'">
							<div libFlexRow [libFlexRowAlign]="'start'">
								@if (clientContextToUse.avatar) {
								<div libFlexColumn [libFlexSize]="'50px'">
									<lib-image
										[image]="clientContextToUse.avatar"
										[imageSize]="'250px'"
										[isResponsive]="true"
										[alt]="'Client avatar'"
									></lib-image>
								</div>
								}
								<div libFlexColumn>
									<div libText2>{{ clientContextToUse.fullName }}</div>
									<div libText3>The Ai has context about this client to give you better answers.</div>
									@if (showEditClientContext()) {
									<div class="push-top-xs">
										<a class="w-no-underline" (click)="openClientContextSelector()"
											>Change client</a
										>
									</div>
									}
								</div>
							</div>
						</div>
						} @else {
						<div libFlexColumn [libFlexSize]="isMobileView() ? 'full' : 'fill'">
							<lib-button (click)="openClientContextSelector()" [icon]="'user'" [buttonType]="'basic'"
								>Select client context</lib-button
							>
						</div>
						}
					</div>
				</lib-card>
			</div>
		</div>
		<div class="push-top" libText3>
			<div>AI can help you write messages or give you ideas.</div>
		</div>
		<div class="push-top">
			<ui-text-area-form-field
				[maxLength]="500"
				[valueAsSignal]="form.prompt"
				[enableGenAi]="false"
				[enableEmoji]="false"
			></ui-text-area-form-field>
		</div>
		<div class="push-top">
			<ui-form-save-button
				[removeDivider]="true"
				[isInDialog]="true"
				[enableControlEnterSaveShortcut]="true"
				[title]="'Submit'"
				[saveHandler]="saveHandler()"
				[logHandler]="formLogHandler()"
				(isLoading)="isLoading.set($event)"
			></ui-form-save-button>
		</div>
		@if (isLoading()) {
		<div class="push-top">
			<div libFlexRow [libFlexRowAlign]="'center'" [libFlexRowGap]="'16px'">
				<div libFlexColumn>
					<lib-loader [loaderType]="'spinner'"></lib-loader>
				</div>
				<div libFlexColumn>
					<div libText3>Generating...</div>
				</div>
			</div>
		</div>
		} } @else { @if (promptResponse(); as promptResponse) {
		<div>
			<div [libFlexRow]="isMobileView()">
				<div libFlexColumn [libFlexSize]="isMobileView() ? 'full' : 'fill'">
					<div libText3>{{ promptSubtitle() }}</div>
				</div>
				<div libFlexColumn [libFlexSize]="isMobileView() ? 'full' : undefined">
					<lib-button (click)="handleCopyText()" [icon]="'copy'" [buttonType]="'basic'">Copy text</lib-button>
				</div>
				<div libFlexColumn [libFlexSize]="isMobileView() ? 'full' : undefined">
					<lib-button (click)="handleEditPrompt()" [icon]="'edit'" [buttonType]="'basic'"
						>Edit prompt</lib-button
					>
				</div>
			</div>

			<lib-card class="push-top-sm">
				<div [innerHTML]="promptResponse.item.generatedText | textToHtml"></div>
			</lib-card>
		</div>
		} }
	</div>

	<div libFlexColumn [libFlexSize]="isMobileView() ? 'full' : '400px'">
		<lib-card [title]="'Previous prompts'">
			<lib-list
				[disableSort]="true"
				[items]="previousPromptListItems()"
				[design]="'selectionList'"
				[pageSize]="7"
			></lib-list>
		</lib-card>
	</div>
</div>
